import { Box } from "@chakra-ui/layout";
import { NamedDateData } from "gen/model/namedDateData";
import { FieldValues, Path, useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useFormFieldPrefix } from "shared/components/form/FormFieldPrefix";
import { FormDateInput } from "shared/components/input/date/DateInput";
import { FormSelect } from "shared/components/input/select/Select";
import { SelectOption } from "shared/components/input/select/SelectOption";

export const NamedDateSelect = <T extends FieldValues>({
  namedDateFieldName,
  customDateFieldName,
  title,
  namedDates,
  isOptional,
  isDisabled,
}: {
  namedDateFieldName: Path<T>;
  customDateFieldName: Path<T>;
  title: string;
  namedDates: NamedDateData[];
  isOptional?: boolean;
  isDisabled?: boolean;
}) => {
  const { t } = useTranslation(["common"]);

  const parentPrefix = useFormFieldPrefix();
  const { control } = useFormContext<T>();

  const value = useWatch({
    control,
    name: parentPrefix
      ? (`${parentPrefix}.${namedDateFieldName}` as Path<T>)
      : namedDateFieldName,
  });

  return (
    <Box>
      <FormSelect
        name={namedDateFieldName}
        title={title}
        isOptional={isOptional}
        isDisabled={isDisabled}
      >
        <SelectOption value="custom">{t("common:custom.custom")}</SelectOption>
        {namedDates.map((namedDate) => (
          <SelectOption key={namedDate.id} value={namedDate.id!}>
            {namedDate.name}
          </SelectOption>
        ))}
      </FormSelect>
      {value === "custom" && (
        <FormDateInput
          name={customDateFieldName}
          title={t("common:custom.date")}
        />
      )}
    </Box>
  );
};
